import React from 'react';

var ToggleButton = function ToggleButton(props) {
  var opened = props.opened,
      handleClick = props.handleClick;
  return React.createElement("button", {
    className: "btn-toggle" + (opened ? ' opened' : ''),
    onClick: handleClick
  }, React.createElement("span", {
    className: "icon"
  }));
};

export default ToggleButton;